import actions from '@/store/modules/product/actions'
import getters from '@/store/modules/product/getters'
import mutations from '@/store/modules/product/mutations'
import state from '@/store/modules/product/state'

export default {
    actions,
    getters,
    mutations,
    state
}